import React from 'react'
import '../../App.css'
import './Mentorship.css'
import { Mentors } from '../Mentor/Mentors'

import web from '../images/img-7.jpg'
import MentorCard from '../Mentor/MentorCard'
export const Mentorship = () => {
  return (
    <>
    <section className="mentorship_wrapper">
        <div className="container">
            <div className="row">
                <div className="order-2 order-lg-1 col-md-7 col-sm-12">
                   <div className="mentorship-text">
                       <h2>Find a Mentor Get Your BrainStromed</h2>
                   </div>
                </div>
                <div className="order-1 order-lg-2 col-md-5 col-sm-12">
                   <div className="mentorship-img">
                      <img src={web} alt="" />
                   </div>
                </div>
            </div>
        </div>
    </section>
    <div className="abcde">
     {/* <Mentors/> */}
     <MentorCard/>
    </div>
    </>
  )
}
